var ServiceClass = function(storage_name) {
	this.storage_name = storage_name;
	this.set = function(k, v) {
		if (typeof v !== "undefined" && v != null) {
			window.localStorage.setItem(this.storage_name + '.' + k, JSON.stringify(v));
			return true;
		}
		return false;
	}
	this.get = function(k) {return JSON.parse(window.localStorage.getItem(this.storage_name+'.'+k));}
	this.remove = function(k) {return window.localStorage.removeItem(this.storage_name+'.'+k);}
	this.clear = function() {return window.localStorage.clear();}
	this.destroy = function() {}
}
export default ServiceClass;
